import { render, staticRenderFns } from "./LaifangChart.vue?vue&type=template&id=96f8ae3e&scoped=true"
import script from "./LaifangChart.vue?vue&type=script&lang=js"
export * from "./LaifangChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96f8ae3e",
  null
  
)

export default component.exports